import * as React from 'react'
import { ReactComponent as LoadIcon } from './../../assets/icons/loader.svg'
import './Loader.scss'

export interface ILoaderProps {
  inverse?: boolean
  top?: boolean
  noPadding?: boolean
}

class Loader extends React.PureComponent<ILoaderProps> {
  BEM = () => {
    const classArray = ['loader']

    if (this.props.inverse) {
      classArray.push('loader--inverse')
    }

    if (this.props.top) {
      classArray.push('loader--top')
    }

    if (this.props.noPadding) {
      classArray.push('loader--no-padding')
    }

    return classArray.join(' ')
  }

  render() {
    return (
      <div className={this.BEM()}>
        <LoadIcon className="loader__svg" />
      </div>
    )
  }
}

export default Loader
